export const AXIOSCALL = {
  AXIOSCALL_SET_SELECTED: "AXIOSCALL_SET_SELECTED",
  AXIOSCALL_CLEAR_SELECTED: "AXIOSCALL_CLEAR_SELECTED",
};
